import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
interface DetailsListProps {
  rows: ReactNode[];
}
export const DetailsList: React.FC<DetailsListProps> = t0 => {
  const $ = _c(4);
  const {
    rows
  } = t0;
  let t1;
  if ($[0] !== rows) {
    t1 = rows.map(_temp);
    $[0] = rows;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col gap-1">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(node, index) {
  return <div className="flex items-center gap-1" key={index}>{node}</div>;
}